/**
 * @generated SignedSource<<a35a1576f0e013807aa01d0ec729b0e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toDeleteAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileDeleteMyAccountScreenQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileDeleteMyAccountScreenQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "58e5e3bb25c47f564f812a3f8a2db490",
    "id": null,
    "metadata": {},
    "name": "ProfileDeleteMyAccountScreenQuery",
    "operationKind": "query",
    "text": "query ProfileDeleteMyAccountScreenQuery {\n  user {\n    id\n    toDeleteAt\n  }\n}\n"
  }
};
})();

node.hash = "b30bae2cfc655613a2130e8a4b45351d";

module.exports = node;
